var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageConvolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5h22.5v22.5H5zM38.8 5h22.5v22.5H38.8zM72.5 5H95v22.5H72.5zM5 38.8h22.5v22.5H5zM38.8 38.8h22.5v22.5H38.8zM72.5 38.8H95v22.5H72.5zM5 72.5h22.5V95H5zM38.8 72.5h22.5V95H38.8zM72.5 72.5H95V95H72.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageConvolution);
export default __webpack_public_path__ + "static/media/imageConvolution.1a0bd9dec8a3a10324c2f3606d636961.svg";
export { ForwardRef as ReactComponent };